import { Checkbox } from '@vipso/shared';
import type { BillingModule } from '../api/adminApi';

export interface ModuleCheckboxListProps {
  modules: BillingModule[];
  selected: string[];
  onChange: (next: string[]) => void;
  /** Append the monthly price to each label. */
  withPrice?: boolean;
}

/** Multi-select of billing modules by id. */
export function ModuleCheckboxList({
  modules,
  selected,
  onChange,
  withPrice,
}: ModuleCheckboxListProps) {
  return (
    <>
      {modules.map((module) => (
        <Checkbox
          key={module.id}
          label={
            withPrice
              ? `${module.name} (₹${Number(module.monthlyPrice)}/mo)`
              : module.name
          }
          checked={selected.includes(module.id)}
          onChange={(e) =>
            onChange(
              e.currentTarget.checked
                ? [...selected, module.id]
                : selected.filter((id) => id !== module.id),
            )
          }
        />
      ))}
    </>
  );
}
